import formsJson from "./forms.json";

const forms=Array.isArray(formsJson) ? formsJson : [];

export const categories=[
  {id: "basicos", label: "Básicos"},
  {id: "secuencias", label: "Secuencias"},
  {id: "formas", label: "Formas"},
  {id: "defensa_personal", label: "Defensa Personal"}
];

const basicTechniques={
  basicos: [
    // Posiciones: nombres y descripciones propuestos, pendientes de validar con el profesor.
    {
      id: "pos-chariot-sogui",
      group: "Posiciones",
      koreanName: "차렷 서기 (Chariot Sogui)",
      spanishName: "Posición de firmes",
      meaning: "Postura de atención y respeto, al formarse y antes del saludo.",
      description: "Pies juntos, piernas extendidas y cuerpo erguido. Los brazos caen a los costados con los puños ligeramente cerrados y la mirada al frente.",
      image: "/assets/techniques/stances/chariot-sogui.webp",
      videoUrl: "#"
    },
    {
      id: "pos-chunbi-sogui",
      group: "Posiciones",
      koreanName: "준비 서기 (Chunbi Sogui)",
      spanishName: "Posición de preparados",
      meaning: "Prepara al practicante mental, física y espiritualmente para la acción.",
      description: "Pies paralelos separados el ancho de un pie. Los puños se colocan frente al Dan Jun, a la altura del cinturón, separados un puño entre sí y con los codos ligeramente flexionados. Se adopta con una respiración controlada antes de iniciar una forma o un ejercicio.",
      image: "/assets/techniques/stances/chunbi-sogui.webp",
      videoUrl: "#"
    },
    {
      id: "pos-moa-sogui",
      group: "Posiciones",
      koreanName: "모아 서기 (Moa Sogui)",
      spanishName: "Pies juntos",
      meaning: "Base estable y cerrada; se usa en el saludo y al inicio de algunas formas.",
      description: "Los bordes internos de los pies quedan juntos, de los talones a las puntas. Piernas extendidas y peso repartido por igual en ambos pies.",
      image: "/assets/techniques/stances/moa-sogui.webp",
      videoUrl: "#"
    },
    {
      id: "pos-naranji-sogui",
      group: "Posiciones",
      koreanName: "나란히 서기 (Naranji Sogui)",
      spanishName: "Pies paralelos",
      meaning: "Postura natural y equilibrada que sirve de base para otras posiciones.",
      description: "Pies paralelos con las puntas al frente, separados el ancho de un pie (aproximadamente el ancho de los hombros). Rodillas extendidas y peso repartido 50% en cada pierna.",
      videoUrl: "#"
    },
    {
      id: "pos-ap-sogui",
      group: "Posiciones",
      koreanName: "앞서기 (Ap Sogui)",
      spanishName: "Posición de caminar",
      meaning: "Postura de paso natural para desplazarse, atacar y defender a corta distancia.",
      description: "Los pies quedan separados la distancia de un paso normal, con ambas piernas extendidas y las puntas al frente. En reposo el peso se reparte 50% en cada pierna; al desplazarse se carga más atrás para defender o más adelante para atacar.",
      image: "/assets/techniques/stances/ap-sogui.webp",
      videoUrl: "#"
    },
    {
      id: "pos-ap-kubi-sogui",
      group: "Posiciones",
      koreanName: "앞굽이 (Ap Kubi Sogui)",
      spanishName: "Posición larga",
      meaning: "Base firme y de gran alcance para ataques y defensas potentes hacia el frente.",
      description: "El pie delantero avanza aproximadamente paso y medio (unos cuatro pies) y se separa un puño a lo ancho. La rodilla delantera se flexiona hasta quedar sobre la punta del pie y la pierna trasera queda extendida, con el pie abierto hasta 30°. Alrededor de dos tercios del peso descansan en la pierna delantera.",
      image: "/assets/techniques/stances/ap-kubi-sogui.webp",
      videoUrl: "#"
    },
    {
      id: "pos-tuit-kubi",
      group: "Posiciones",
      koreanName: "뒷굽이 (Tuit Kubi)",
      spanishName: "Posición atrasada",
      meaning: "Postura defensiva que deja libre la pierna delantera para patear.",
      description: "Los pies forman un ángulo de 90° (en L), separados unos dos pies. Ambas rodillas se flexionan y el peso se carga 70% en la pierna trasera y 30% en la delantera.",
      image: "/assets/techniques/stances/tuit-kubi.webp",
      videoUrl: "#"
    },
    {
      id: "pos-uen-sogui",
      group: "Posiciones",
      koreanName: "왼 서기 (Uen Sogui)",
      spanishName: "Posición en L izquierda",
      meaning: "Postura de transición y de orientación hacia la izquierda.",
      description: "El pie derecho apunta al frente y el pie izquierdo gira 90° hacia la izquierda, formando una L. Piernas extendidas y peso repartido en ambos pies.",
      image: "/assets/techniques/stances/uen-sogui.webp",
      videoUrl: "#"
    },
    {
      id: "pos-orun-sogui",
      group: "Posiciones",
      koreanName: "오른 서기 (Orun Sogui)",
      spanishName: "Posición en L derecha",
      meaning: "Postura de transición y de orientación hacia la derecha.",
      description: "El pie izquierdo apunta al frente y el pie derecho gira 90° hacia la derecha, formando una L. Piernas extendidas y peso repartido en ambos pies.",
      image: "/assets/techniques/stances/orun-sogui.webp",
      videoUrl: "#"
    },
    {
      id: "pos-tuit-koa-sogui",
      group: "Posiciones",
      koreanName: "뒤꼬아 서기 (Tuit Koa Sogui)",
      spanishName: "Cruzada por detrás",
      meaning: "Postura de transición para desplazamientos laterales y para preparar patadas.",
      description: "El pie de atrás cruza por detrás del pie de apoyo y se apoya solo con la parte delantera de la planta. Ambas rodillas se flexionan y el peso descansa principalmente en la pierna delantera.",
      image: "/assets/techniques/stances/tuit-koa-sogui.webp",
      videoUrl: "#"
    },
    {
      id: "pos-bon-sogui",
      group: "Posiciones",
      koreanName: "범 서기 (Bon Sogui)",
      spanishName: "Posición del tigre",
      meaning: "Postura ágil que permite defender y patear rápido con la pierna delantera.",
      description: "El pie delantero se apoya ligeramente sobre la parte delantera de la planta, a un pie de distancia del pie trasero. Ambas rodillas se flexionan y casi todo el peso descansa en la pierna trasera.",
      image: "/assets/techniques/stances/bon-sogui.webp",
      videoUrl: "#"
    },
    {
      id: "pos-chu-chum-sogui",
      group: "Posiciones",
      koreanName: "주춤 서기 (Chu Chum Sogui)",
      spanishName: "Posición de jinete",
      meaning: "Postura estable que fortalece las piernas y da base para técnicas hacia los lados.",
      description: "Pies paralelos con las puntas al frente, separados unos dos pies. Las rodillas se flexionan empujando hacia afuera, la espalda queda recta y el peso se reparte 50% en cada pierna, como si se montara a caballo.",
      image: "/assets/techniques/stances/chu-chum-sogui.webp",
      videoUrl: "#"
    },
    {
      id: "pos-ap-koa-sogui",
      group: "Posiciones",
      koreanName: "앞꼬아 서기 (Ap Koa Sogui)",
      spanishName: "Cruzada por delante",
      meaning: "Postura de transición para avanzar o desplazarse lateralmente.",
      description: "El pie que se mueve cruza por delante del pie de apoyo. Ambas rodillas se flexionan y el peso descansa principalmente en la pierna que cruzó.",
      image: "/assets/techniques/stances/ap-koa-sogui.webp",
      videoUrl: "#"
    },
    {
      id: "pos-jakdari-sogui",
      group: "Posiciones",
      koreanName: "학다리 서기 (Jakdari Sogui)",
      spanishName: "Posición de la grulla",
      meaning: "Postura de equilibrio sobre una sola pierna.",
      description: "Se apoya todo el peso en una pierna con la rodilla ligeramente flexionada. El pie de la otra pierna se coloca junto a la rodilla de apoyo, por su cara interna.",
      image: "/assets/techniques/stances/jakdari-sogui.webp",
      videoUrl: "#"
    },
    {
      id: "pos-kiotari-sogui",
      group: "Posiciones",
      koreanName: "곁다리 서기 (Kiotari Sogui)",
      spanishName: "Pie de apoyo al tobillo",
      meaning: "Postura de transición para cambiar de dirección o preparar una técnica.",
      description: "Todo el peso descansa en una pierna con la rodilla ligeramente flexionada. La parte delantera de la planta del otro pie se apoya junto al tobillo de la pierna de apoyo.",
      image: "/assets/techniques/stances/kiotari-sogui.webp",
      videoUrl: "#"
    },
    {
      id: "pos-ogum-sogui",
      group: "Posiciones",
      koreanName: "오금 서기 (Ogum Sogui)",
      spanishName: "Posición de la corva",
      meaning: "Postura de equilibrio que protege la pierna recogida y prepara una patada.",
      description: "Todo el peso descansa en una pierna con la rodilla ligeramente flexionada. El empeine del otro pie se coloca detrás de la corva (la parte posterior de la rodilla) de la pierna de apoyo.",
      image: "/assets/techniques/stances/ogum-sogui.webp",
      videoUrl: "#"
    },
    {
      id: "d1",
      group: "Defensas",
      koreanName: "아래 막기 (Arae Makki)",
      spanishName: "Defensa Baja",
      beltType: "blanca",
      meaning: "Bloqueo para proteger la zona inferior (Dan Jun).",
      description: "Partiendo del hombro contrario, el brazo desciende con fuerza barriendo hacia afuera.",
      videoUrl: "#"
    },
    {
      id: "d2",
      group: "Defensas",
      koreanName: "몸통 안 막기 (Momtong An Makki)",
      spanishName: "Defensa Media Interior",
      beltType: "amarilla",
      meaning: "Bloqueo circular hacia el interior para proteger el plexo solar.",
      description: "El antebrazo viaja desde el exterior hacia el centro del pecho.",
      videoUrl: "#"
    },
    {
      id: "d3",
      group: "Defensas",
      koreanName: "얼굴 막기 (Olgul Makki)",
      spanishName: "Defensa Alta",
      beltType: "blanca_avanzada",
      meaning: "Bloqueo ascendente para proteger la cabeza.",
      description: "El brazo sube cruzando el rostro, terminando inclinado sobre la frente.",
      videoUrl: "#"
    },
    {
      id: "p1",
      group: "Pateo",
      koreanName: "앞 차기 (Ap Chagi)",
      spanishName: "Patada Frontal",
      beltType: "blanca",
      meaning: "Ataque directo con el metatarso.",
      description: "Elevación de rodilla, extensión explosiva y retracción rápida.",
      videoUrl: "#"
    },
    {
      id: "p2",
      group: "Pateo",
      koreanName: "돌려 차기 (Tollyo Chagi)",
      spanishName: "Patada Circular",
      beltType: "amarilla",
      meaning: "Ataque semicircular al tronco con el empeine.",
      description: "Giro del pie de apoyo y la cadera para impactar lateralmente.",
      videoUrl: "#"
    }
  ],
  secuencias: [
    {
      id: "bc1",
      group: "Básicos con contraataque",
      koreanName: "일보 (Il Bon)",
      spanishName: "Básico con contraataque 1",
      beltType: "amarilla",
      videoUrl: "https://youtu.be/j4czpOAGj_8"
    },
    {
      id: "bc2",
      group: "Básicos con contraataque",
      koreanName: "이보 (I Bon)",
      spanishName: "Básico con contraataque 2",
      beltType: "amarilla",
      videoUrl: "https://youtu.be/XQjEOf1ZZ2g"
    },
    {
      id: "bc3",
      group: "Básicos con contraataque",
      koreanName: "삼보 (Sam Bon)",
      spanishName: "Básico con contraataque 3",
      beltType: "amarilla",
      videoUrl: "https://youtu.be/Ez5EJ1hNDhs"
    },
    {
      id: "bc4",
      group: "Básicos con contraataque",
      koreanName: "사보 (Sa Bon)",
      spanishName: "Básico con contraataque 4",
      beltType: "amarilla",
      videoUrl: "https://youtu.be/fBNqOjFpjaE"
    },
    {
      id: "sb1",
      group: "Secuencias básicas",
      koreanName: "일보 (Il Bon)",
      spanishName: "Secuencia básica 1",
      beltType: "verde",
      videoUrl: "https://youtu.be/1oXtV6sVtM0"
    },
    {
      id: "sb2",
      group: "Secuencias básicas",
      koreanName: "이보 (I Bon)",
      spanishName: "Secuencia básica 2",
      beltType: "verde",
      videoUrl: "https://youtu.be/e3SzOH_GigE"
    },
    {
      id: "sb3",
      group: "Secuencias básicas",
      koreanName: "삼보 (Sam Bon)",
      spanishName: "Secuencia básica 3",
      beltType: "verde",
      videoUrl: "https://youtu.be/6qDFJ-Gxu_E"
    },
    {
      id: "sb4",
      group: "Secuencias básicas",
      koreanName: "사보 (Sa Bon)",
      spanishName: "Secuencia básica 4",
      beltType: "verde",
      videoUrl: "https://youtu.be/nYuI7WenssA"
    },
    {
      id: "sb5",
      group: "Secuencias básicas",
      koreanName: "오보 (O Bon)",
      spanishName: "Secuencia básica 5",
      beltType: "azul",
      videoUrl: "https://youtu.be/5dXv7CH-2BM"
    },
    {
      id: "sb6",
      group: "Secuencias básicas",
      koreanName: "육보 (Yuk Bon)",
      spanishName: "Secuencia básica 6",
      beltType: "azul",
      videoUrl: "https://youtu.be/eZGU8btZWN8"
    },
    {
      id: "sb7",
      group: "Secuencias básicas",
      koreanName: "칠보 (Chil Bon)",
      spanishName: "Secuencia básica 7",
      beltType: "azul",
      videoUrl: "https://youtu.be/CGush1ukMFU"
    },
    {
      id: "sb8",
      group: "Secuencias básicas",
      koreanName: "팔보 (Pal Bon)",
      spanishName: "Secuencia básica 8",
      beltType: "azul",
      videoUrl: "https://youtu.be/Y4_LV3pUzmA"
    },
    {
      id: "si1",
      group: "Secuencias intermedias",
      koreanName: "일보 (Il Bon)",
      spanishName: "Secuencia intermedia 1",
      beltType: "azul_avanzada",
      videoUrl: "https://youtu.be/yqTZQ-rFCMI"
    },
    {
      id: "si2",
      group: "Secuencias intermedias",
      koreanName: "이보 (I Bon)",
      spanishName: "Secuencia intermedia 2",
      beltType: "azul_avanzada",
      videoUrl: "https://youtu.be/jkHr4ErpKE8"
    },
    {
      id: "si3",
      group: "Secuencias intermedias",
      koreanName: "삼보 (Sam Bon)",
      spanishName: "Secuencia intermedia 3",
      beltType: "azul_avanzada",
      videoUrl: "https://youtu.be/qDxfBYp1ZoA"
    },
    {
      id: "si4",
      group: "Secuencias intermedias",
      koreanName: "사보 (Sa Bon)",
      spanishName: "Secuencia intermedia 4",
      beltType: "azul_avanzada",
      videoUrl: "https://youtu.be/XgzOgOXVFOA"
    },
    {
      id: "si5",
      group: "Secuencias intermedias",
      koreanName: "오보 (O Bon)",
      spanishName: "Secuencia intermedia 5",
      beltType: "marron_avanzada",
      videoUrl: "https://youtu.be/zS4vCTNzDPQ"
    },
    {
      id: "si6",
      group: "Secuencias intermedias",
      koreanName: "육보 (Yuk Bon)",
      spanishName: "Secuencia intermedia 6",
      beltType: "marron_avanzada",
      videoUrl: "https://youtu.be/ozcVKdYJvs4"
    },
    {
      id: "si7",
      group: "Secuencias intermedias",
      koreanName: "칠보 (Chil Bon)",
      spanishName: "Secuencia intermedia 7",
      beltType: "marron_avanzada",
      videoUrl: "https://youtu.be/DITZyGJv8_M"
    },
    {
      id: "si8",
      group: "Secuencias intermedias",
      koreanName: "팔보 (Pal Bon)",
      spanishName: "Secuencia intermedia 8",
      beltType: "marron_avanzada",
      videoUrl: "https://youtu.be/vJDkSHWuH24"
    },
    {
      id: "si9",
      group: "Secuencias intermedias",
      koreanName: "구보 (Gu Bon)",
      spanishName: "Secuencia intermedia 9",
      beltType: "marron_avanzada",
      videoUrl: "https://youtu.be/wsWl3zEeA-I"
    },
    {
      id: "si10",
      group: "Secuencias intermedias",
      koreanName: "십보 (Sip Bon)",
      spanishName: "Secuencia intermedia 10",
      beltType: "marron_avanzada",
      videoUrl: "https://youtu.be/lrBzT0e_ZJg"
    },
    {
      id: "sn1",
      group: "Secuencias de cinta negra",
      koreanName: "Secuencia de Cinta Negra 1",
      spanishName: "",
      beltType: "negra_1",
      description: "Secuencia de combate pactado.",
      videoUrl: "#"
    },
    {
      id: "sn2",
      group: "Secuencias de cinta negra",
      koreanName: "Secuencia de Cinta Negra 2",
      spanishName: "",
      beltType: "negra_1",
      description: "Secuencia de combate pactado.",
      videoUrl: "#"
    },
    {
      id: "sn3",
      group: "Secuencias de cinta negra",
      koreanName: "Secuencia de Cinta Negra 3",
      spanishName: "",
      beltType: "negra_1",
      description: "Secuencia de combate pactado.",
      videoUrl: "#"
    },
    {
      id: "sn4",
      group: "Secuencias de cinta negra",
      koreanName: "Secuencia de Cinta Negra 4",
      spanishName: "",
      beltType: "negra_1",
      description: "Secuencia de combate pactado.",
      videoUrl: "#"
    },
    {
      id: "sn5",
      group: "Secuencias de cinta negra",
      koreanName: "Secuencia de Cinta Negra 5",
      spanishName: "",
      beltType: "negra_2",
      description: "Secuencia de combate pactado.",
      videoUrl: "#"
    },
    {
      id: "sn6",
      group: "Secuencias de cinta negra",
      koreanName: "Secuencia de Cinta Negra 6",
      spanishName: "",
      beltType: "negra_2",
      description: "Secuencia de combate pactado.",
      videoUrl: "#"
    },
    {
      id: "sn7",
      group: "Secuencias de cinta negra",
      koreanName: "Secuencia de Cinta Negra 7",
      spanishName: "",
      beltType: "negra_2",
      description: "Secuencia de combate pactado.",
      videoUrl: "#"
    },
    {
      id: "sn8",
      group: "Secuencias de cinta negra",
      koreanName: "Secuencia de Cinta Negra 8",
      spanishName: "",
      beltType: "negra_2",
      description: "Secuencia de combate pactado.",
      videoUrl: "#"
    },
    {
      id: "sn9",
      group: "Secuencias de cinta negra",
      koreanName: "Secuencia de Cinta Negra 9",
      spanishName: "",
      beltType: "negra_2",
      description: "Secuencia de combate pactado.",
      videoUrl: "#"
    },
    {
      id: "sn10",
      group: "Secuencias de cinta negra",
      koreanName: "Secuencia de Cinta Negra 10",
      spanishName: "",
      beltType: "negra_2",
      description: "Secuencia de combate pactado.",
      videoUrl: "#"
    },
    {
      id: "sn11",
      group: "Secuencias de cinta negra",
      koreanName: "Secuencia de Cinta Negra 11",
      spanishName: "",
      beltType: "negra_2",
      description: "Secuencia de combate pactado.",
      videoUrl: "#"
    },
    {
      id: "sn12",
      group: "Secuencias de cinta negra",
      koreanName: "Secuencia de Cinta Negra 12",
      spanishName: "",
      beltType: "negra_2",
      description: "Secuencia de combate pactado.",
      videoUrl: "#"
    }
  ],
  defensa_personal: [
    {
      id: "dp1",
      koreanName: "호신술 (Ho Shin Sul)",
      spanishName: "Defensa Personal Básica",
      beltType: "azul",
      meaning: "Técnicas de escape y control ante agarres.",
      description: "Uso de puntos de presión y palancas.",
      videoUrl: "#"
    }
  ]
};

export const techniquesData={
  ...basicTechniques,
  formas: forms
};

// Grupos cuyo contenido aún no se publica: no se muestran las tarjetas y aparece "Próximamente".
export const comingSoonGroups={
  basicos: ["Defensas","Pateo"],
  secuencias: ["Secuencias de cinta negra"]
};
